window.visibleFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<i class="fontawesome fas fa-eye" title="' + __('Visible') + '"></i>';
    } else {
        html += '<i class="fontawesome fas fa-eye-slash" title="' + __('Not visible') + '"></i>';
    }
    return html;
}
